import { render } from "./ImageAsideAlt.vue?vue&type=template&id=d074faa6&scoped=true"
import script from "./ImageAsideAlt.vue?vue&type=script&lang=js"
export * from "./ImageAsideAlt.vue?vue&type=script&lang=js"

import "./ImageAsideAlt.vue?vue&type=style&index=0&id=d074faa6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d074faa6"

export default script